import { OptionType } from '../types';

export default function () {
    const languages: OptionType[] = [
        {
            label: '🇬🇧 English',
            value: 'en_US',
        },
        {
            label: '🇵🇱 Polish',
            value: 'pl_PL',
        },
        {
            label: '🇫🇷 French',
            value: 'fr_FR',
        },
        {
            label: '🇩🇪 German',
            value: 'de_DE',
        },
        {
            label: '🇪🇸 Spanish',
            value: 'es_ES',
        },
        {
            label: '🇮🇹 Italian',
            value: 'it_IT',
        },
        {
            label: '🇵🇹 Portuguese',
            value: 'pt_PT',
        },
        {
            label: '🇷🇺 Russian',
            value: 'ru_RU',
        },
        {
            label: '🇦🇪 Arabic',
            value: 'ar_AR',
        },
        {
            label: '🇮🇳 Hindi',
            value: 'hi_IN',
        },
        {
            label: '🇨🇳 Chinese',
            value: 'zh_CN',
        },
    ];

    return languages;
}
